var map = {
	"./0.png": "af51",
	"./1.png": "80c4",
	"./2.png": "4008",
	"./3.png": "7c5a",
	"./4.png": "db75",
	"./5.png": "27bc",
	"./6.png": "39d0",
	"./7.png": "4c9f",
	"./8.png": "4907",
	"./horizontal/1.png": "0a9b",
	"./horizontal/2.png": "b2d3",
	"./horizontal/3.png": "0557",
	"./horizontal/4.png": "ac22",
	"./horizontal/5.png": "1ba8",
	"./horizontal/6.png": "1849",
	"./horizontal/7.png": "4373",
	"./horizontal/8.png": "c284",
	"./vertical/1.png": "3b4e",
	"./vertical/2.png": "3b67",
	"./vertical/3.png": "eeb5",
	"./vertical/4.png": "8ee1",
	"./vertical/5.png": "3aa4",
	"./vertical/6.png": "31db",
	"./vertical/7.png": "3aaa",
	"./vertical/8.png": "1913"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fd82";